export enum MessageSource {
  AcceptTerms = 'ACCEPT_TERMS',
  ResetPassword = 'RESET_PASSWORD',
  ReactivateAccountSuccess = 'REACTIVATE_ACCOUNT_SUCCESS',
  ReactivateAccountFailure = 'REACTIVATE_ACCOUNT_FAILURE',
}
